import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { SparkToggleSwitch } from '../ui/spark';

class ConfigurationCheckbox extends Component {
    componentDidMount() {
        this.checkBox = new SparkToggleSwitch(this.checkboxMount);
    }

    render() {
        const {
            className,
            labelClassName,
            title,
            desc,
            isDisabled,
            onChange,
            code,
            value,
            style,
            inverse,
            TitleTag = 'span'
        } = this.props;
        // sometimes our configurations are negative, but they are presented to the user as positive for clarity
        // ex. disableChildrenSelection displays as 'Guest can specify children'
        // This means we need the value of the checkbox to actually be the inverse of the config value
        const onChangeValue = inverse ? !value : value;
        const labelClass = classNames('col-xs-12', 'spark-checkbox', labelClassName);

        return (
            <div style={style} className={className}>
                <label className={labelClass} ref={node => (this.checkboxMount = node)}>
                    <input
                        className="spark-checkbox__input"
                        type="checkbox"
                        disabled={isDisabled}
                        onChange={() => onChange(code, onChangeValue)}
                        checked={value}
                    />
                    <span className="spark-checkbox__box" />
                    <span className="spark-label">
                        <TitleTag>{title}</TitleTag>
                        {desc && <p>{desc}</p>}
                    </span>
                </label>
            </div>
        );
    }
}

ConfigurationCheckbox.propTypes = {
    className: PropTypes.string,
    code: PropTypes.string.isRequired,
    desc: PropTypes.string,
    inverse: PropTypes.bool,
    isDisabled: PropTypes.bool,
    labelClassName: PropTypes.string,
    style: PropTypes.object,
    title: PropTypes.string,
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

ConfigurationCheckbox.defaultProps = {
    className: '',
    desc: '',
    inverse: false,
    isDisabled: false,
    labelClassName: '',
    style: {},
    title: ''
};

export default ConfigurationCheckbox;



// WEBPACK FOOTER //
// ./src/components/widgets/ConfigurationCheckbox.js